import React from 'react';

import LinearProgress from '@material-ui/core/LinearProgress';

import AppActions from '../../../actions/app-actions';
import { AppContext } from '../../../contexts/app-context';
import AppStore from '../../../stores/app-store';

import ReleaseRepository from './releaserepository';
import ReleasesList from './releaseslist';

export default class Artifacts extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      refreshArtifactsLength: 30000, //60000,
      doneLoading: false,
      ...this._getState()
    };
    /** Bind methods to avoid method re-creation */
    this._onChangeBind = this._onChange.bind(this);
  }
  UNSAFE_componentWillMount() {
    AppStore.changeListener(this._onChangeBind);
  }
  componentDidMount() {
    this.artifactTimer = setInterval(() => this._getReleases(), this.state.refreshArtifactsLength);
    this._getReleases();
  }
  componentWillUnmount() {
    clearInterval(this.artifactTimer);
    AppStore.removeChangeListener(this._onChangeBind);
  }
  _getState() {
    const releases = AppStore.getReleases();
    let selectedRelease = this.state ? this.state.selectedRelease : null;
    const staleSelection = selectedRelease && !releases.find(item => item.name === selectedRelease.name);
    if (staleSelection || (!selectedRelease && releases.length)) {
      selectedRelease = releases[0];
    }
    if (this.state && this.state.releases.length < releases.length) {
      selectedRelease = releases.find(release => this.state.releases.every(item => item.Name !== release.Name));
    }
    return {
      releases,
      selectedRelease,
      remove: false,
      showHelptips: AppStore.showHelptips()
    };
  }
  _onChange() {
    const self = this;
    let state = self._getState();
    if (this.props.params) {
      if (this.props.params.artifactVersion) {
        // selected artifacts
        var artifact = AppStore.getSoftwareArtifact('name', this.props.params.artifactVersion);
        state.selectedRelease = self.state.releases.find(item => item.Artifacts.find(releaseArtifact => releaseArtifact.id === artifact.id));
        state.selectedArtifact = artifact;
      }
    }
    self.setState(state);
  }

  onSelectRelease(release) {
    this.setState({ selectedRelease: release });
  }

  onFilterReleases(releases) {
    let selectedRelease = this.state.selectedRelease;
    if (releases && !releases.find(item => selectedRelease && selectedRelease.Name === item.Name)) {
      selectedRelease = releases.length ? releases[0] : null;
    }
    if (this.state.selectedRelease !== selectedRelease) {
      this.setState({ selectedRelease });
    }
  }

  _getReleases() {
    var self = this;
    return Promise.all([AppActions.getReleases(), AppActions.getArtifacts()])
      .catch(err => {
        var errormsg = err.error || 'Please check your connection';
        AppActions.setSnackbar(errormsg, 5000, '');
        console.log(errormsg);
      })
      .finally(() => {
        self.setState({ doneLoading: true });
      });
  }

  render() {
    const self = this;
    const { doneLoading, selectedRelease, showHelptips, releases } = self.state;
    const { artifactProgress } = self.props;
    const currentSelectedRelease = releases.find(item => selectedRelease && item.Name === selectedRelease.Name);
    return (
      <div style={{ height: '100%' }}>
        <div className="flexbox" style={{ height: '100%' }}>
          <ReleasesList
            releases={releases}
            selectedRelease={currentSelectedRelease}
            onSelect={release => self.onSelectRelease(release)}
            onFilter={releases => self.onFilterReleases(releases)}
            loading={!doneLoading}
          />
          <AppContext.Consumer>
            {({ uploadArtifact }) => (
              <ReleaseRepository
                artifacts={currentSelectedRelease ? currentSelectedRelease.Artifacts : []}
                uploadArtifact={uploadArtifact}
                showHelptips={showHelptips}
                refreshArtifacts={() => self._getReleases()}
                loading={!doneLoading}
                release={currentSelectedRelease}
                hasReleases={releases.length}
              />
            )}
          </AppContext.Consumer>
        </div>
        {artifactProgress ? (
          <div id="progressBarContainer">
            <p className="align-center">Upload in progress ({Math.round(artifactProgress)}%)</p>
            <LinearProgress variant="determinate" style={{ backgroundColor: '#c7c7c7', margin: '15px 0' }} value={artifactProgress} />
          </div>
        ) : null}
      </div>
    );
  }
}
